import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

/**
 * Signup is closed (`disableSignUp` in `packages/auth/auth.ts`). Kept so old
 * links and bookmarks land on `/login` instead of a 404.
 */
export const Route = createFileRoute("/signup")({
  validateSearch: z.object({
    redirect: z
      .string()
      .optional()
      .refine((v) => !v || (v.startsWith("/") && !v.startsWith("//"))),
  }),
  beforeLoad: ({ search }) => {
    throw redirect({
      to: "/login",
      search: { redirect: search.redirect },
      replace: true,
    });
  },
});
